import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetCollectionChallengeIdsRequest } from './get-collection-challenge-ids-request';
import type { IGetCollectionChallengeIdsResponse } from './get-collection-challenge-ids-response';
import { getCollectionChallengeIdsResponseSchema } from './get-collection-challenge-ids-response';

export async function getCollectionChallengeIdsApi({
  id,
}: IGetCollectionChallengeIdsRequest): Promise<
  IValidatedResponse<IGetCollectionChallengeIdsResponse>
> {
  return getRequest<IGetCollectionChallengeIdsResponse>({
    path: `/sys/collections/${id}/challenge-ids`,
    schema: getCollectionChallengeIdsResponseSchema,
  });
}
